import { useSuspenseQuery } from '@tanstack/react-query';
import { getEditProposalInformation, IAPPROPOSALSTATUS } from 'bff';
import { useProposalIdFromParams } from 'hooks/useProposalIdFromParams';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { generateEditProposalPath } from 'routes/route-paths';
import { assertIsDefined } from '@sanlam-glacier/app-common/utils';

type ProposalStatusGuardProps = {
  component: React.ReactNode;
  requiredProposalStatus: IAPPROPOSALSTATUS[];
  backupRoute: string;
};

export const ProposalStatusGuard = ({
  component,
  requiredProposalStatus,
  backupRoute
}: ProposalStatusGuardProps) => {
  const proposalId = useProposalIdFromParams();
  assertIsDefined(proposalId);
  const proposalData = useSuspenseQuery(getEditProposalInformation({ proposalId }));

  if (!proposalData.data.status) throw new Error('No proposal status');

  if (requiredProposalStatus.includes(proposalData.data.status)) return component;

  return <Navigate to={`${generateEditProposalPath(proposalId)}/${backupRoute}`} />;
};
